import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "It's truly enriching to see how enthusiastically students like Kristijana and Matevž worked on such a complex project. Understanding the overall project, comprehending the existing code, and then transferring it to a new framework and different maps was a challenge. But the result speaks for itself.",
      name: 'Bojan Ramšak',
      title: 'Head of Transmitters and Communications Development, RTV Slovenia',
      link: 'https://www.linkedin.com/feed/update/urn:li:activity:7475457633655611393/'
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonials-container">
        <div className="section-header">
          <h2 className="section-title pink-bg">WHAT PEOPLE SAY</h2>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <svg className="quote-icon" width="40" height="30" viewBox="0 0 40 30" fill="#ff1493">
                <text x="0" y="26" fontSize="42" fontFamily="Georgia, serif" fontWeight="700">"</text>
              </svg>
              <p className="testimonial-quote">{testimonial.quote}</p>
              <div className="testimonial-author">
                <div>
                  <h4 className="testimonial-name">{testimonial.name}</h4>
                  <p className="testimonial-title">{testimonial.title}</p>
                </div>
                {testimonial.link && (
                  <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="testimonial-linkedin" aria-label={`${testimonial.name} on LinkedIn`}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.22 24h4.56V7.98H.22V24zM8.98 7.98H13.3v2.19h.06c.6-1.13 2.07-2.32 4.26-2.32 4.56 0 5.4 3 5.4 6.9V24h-4.56v-7.96c0-1.9-.03-4.35-2.65-4.35-2.65 0-3.06 2.07-3.06 4.2V24H8.98V7.98z"/>
                    </svg>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
